export default __webpack_public_path__ + "static/media/Help.7662f750.svg";